import { render, staticRenderFns } from "./AskCenAiPage.vue?vue&type=template&id=24b8e5cc&scoped=true"
import script from "./AskCenAiPage.vue?vue&type=script&lang=ts"
export * from "./AskCenAiPage.vue?vue&type=script&lang=ts"
import style0 from "./AskCenAiPage.vue?vue&type=style&index=0&id=24b8e5cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b8e5cc",
  null
  
)

export default component.exports